import { P2GText } from '@parcel2go/core-ui';
import { AsyncLinks } from './AsyncLinks';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { useInvoiceApi } from '~/lib/api/invoice/use-invoice-api';
import { useMemo, useState } from 'react';
import useOnLoad from '~/routes/use-on-load';
import { ShipResponse } from '~/lib/api/smartsend/types';

interface props {
  shipResponse: ShipResponse;
  wrapper: (children: React.ReactNode) => React.ReactNode;
}

const ProviderGroupSummaryInvoice: React.FC<props> = ({ shipResponse, wrapper }) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const { getSignedInvoiceUrl } = useInvoiceApi();
  const [presigned, setPresigned] = useState<string>(null);

  useOnLoad(() => {
    const loadInvoice = async () => {
      const orderId = Number(shipResponse.Reference);
      if (isNaN(orderId)) {
        return;
      }

      const res = await getSignedInvoiceUrl(orderId);
      if (res.success && res.result.preSignedUrl) {
        setPresigned(res.result.preSignedUrl);
      }
    };
    try {
      if (!shipResponse.Links.some((x) => x.Type.includes('INVOICE'))) {
        loadInvoice();
      }
    } catch (error) {
      console.error('Error loading invoice presigned URL', error);
    }
  });

  const links = useMemo(() => {
    if (presigned) {
      return [
        {
          Label: `Download\nInvoice`,
          Type: 'ORDER-INVOICE_DOWNLOAD',
          Href: presigned
        }
      ];
    }

    return shipResponse?.Links?.filter((x) => x.Type.includes('INVOICE')) || [];
  }, [shipResponse.Links, presigned]);

  if (links.some((x) => x.Type.includes('INVOICE'))) {
    return (
      <AsyncLinks
        wrapper={wrapper}
        variant="list"
        tag={`Order ${shipResponse.Reference}`}
        links={links}
        title={null}
        match={(x) => x.Type.includes('INVOICE')}
      >
        <P2GText component="p" colour="primary">
          <strong>
            <Trans t={t} i18nKey="PROVIDER_SUMMARY_INVOICE" defaults="Invoice" />
          </strong>
        </P2GText>
      </AsyncLinks>
    );
  }

  return null;
};

export default ProviderGroupSummaryInvoice;
